import { render, staticRenderFns } from "./tableau-de-bord.html?vue&type=template&id=bccd157a&scoped=true&external"
import script from "./tableau-de-bord.js?vue&type=script&lang=js&external"
export * from "./tableau-de-bord.js?vue&type=script&lang=js&external"
import style0 from "./tableau-de-bord.scss?vue&type=style&index=0&id=bccd157a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccd157a",
  null
  
)

export default component.exports